export default "/fonts/vendor/katex/dist/KaTeX_Size2-Regular.woff?3a99e70aee4076660d38b312c7cac2f9";